import React from "react";
import "./Profile.scss"
import {SwurfSpinner} from "../../components/SwurfSpinner";
import {useSelector} from "react-redux";
import {selectIsLoading as selectProfileLoading} from "../auth/authSlice";
import {EditProfile} from "./EditProfile";

export const Profile = () => {
  const loading = useSelector(selectProfileLoading)

  return (
      <div className={"Profile contentArea"}>
        <SwurfSpinner loading={loading} />
        <div className={"content"}>
          <EditProfile />
        </div>
      </div>
  )
}
